import React from 'react';
import { Select } from '../components/ui/Select';
import { Icon } from '@iconify/react';
const stats = [{
  label: 'Candidature Inviate',
  value: '124',
  icon: 'tabler:file-check'
}, {
  label: 'Candidature in Bozza',
  value: '159',
  icon: 'tabler:file-text'
}, {
  label: 'Istituzioni Scolastiche Registrate',
  value: '64',
  icon: 'tabler:school'
}, {
  label: 'Altri Soggetti Giuridici Registrati',
  value: '176',
  icon: 'tabler:building'
}];
const categories = [{
  label: 'Arti Visive, performative e multimediali',
  val: 16,
  color: '#00497A'
}, {
  label: 'Libro e Lettura',
  val: 9,
  color: '#0E74B8'
}, {
  label: 'Cinema',
  val: 6,
  color: '#2A97DF'
}, {
  label: 'Musica',
  val: 5,
  color: '#98C3EC'
}, {
  label: 'Danza',
  val: 2,
  color: '#D7EDFF'
}, {
  label: 'Teatro',
  val: 2,
  color: '#061A40'
}];
export function Dashboard() {
  const maxCategoryValue = 16;
  return <div className="space-y-6 pb-12" data-id="element-870">
      {/* Page Header */}
      <div className="bg-white flex items-center justify-between px-8 py-6" style={{
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-871">
        <h1 className="m-0" style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif'
      }} data-id="element-872">
          Homepage
        </h1>
        <button className="flex items-center gap-2 text-white transition-colors hover:opacity-90" style={{
        backgroundColor: '#293B54',
        borderRadius: '9999px',
        fontFamily: 'Roboto Condensed, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        border: 'none',
        cursor: 'pointer',
        padding: '10px 20px'
      }} data-id="element-873">
          <Icon icon="tabler:download" fontSize={18} data-id="element-874" />
          Esporta dati
        </button>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-875">
        {stats.map((stat, index) => <div key={index} className="bg-white flex flex-col justify-between" style={{
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        padding: '24px'
      }} data-id="element-876">
            <div className="mb-3" data-id="element-877">
              <Icon icon={stat.icon} fontSize={22} style={{
            color: '#2A97DF',
            strokeWidth: 1.5
          }} data-id="element-878" />
            </div>
            <div data-id="element-879">
              <div style={{
            fontFamily: 'Roboto Condensed, sans-serif',
            color: '#293B54',
            lineHeight: 1.2
          }} className="text-[24px] font-[400]" data-id="element-880">
                {stat.value}
              </div>
              <div style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px',
            color: '#80858E',
            marginTop: '4px'
          }} data-id="element-881">
                {stat.label}
              </div>
            </div>
          </div>)}
      </div>

      {/* Dettaglio Candidature Section */}
      <div className="bg-white p-8" style={{
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-882">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-8" data-id="element-883">
          <h2 style={{
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '20px',
          fontWeight: 400,
          color: '#293B54',
          margin: 0
        }} data-id="element-884">
            Dettaglio Candidature
          </h2>
          <div className="flex gap-4" data-id="element-885">
            <Select options={[{
            value: 'bando1',
            label: 'Bando 1 - Nuove Opere'
          }]} className="w-[280px] border-[#E4E4E4] text-[#444444]" data-id="element-886" />
            <Select options={[{
            value: 'inviate',
            label: 'Inviate'
          }]} className="w-[120px] border-[#E4E4E4] text-[#444444]" data-id="element-887" />
          </div>
        </div>

        {/* Horizontal Bars */}
        <div data-id="element-888">
          {categories.map((item, idx) => {
          const pct = Math.round(item.val / maxCategoryValue * 100);
          return <div key={idx} className="flex items-center gap-6" style={{
            padding: '14px 0',
            borderBottom: idx < categories.length - 1 ? '1px solid #F5F5F5' : 'none'
          }} data-id="element-889">
                <div className="w-[260px] flex-shrink-0 truncate" title={item.label} style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#444444'
            }} data-id="element-890">
                  {item.label}
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-891">
                  <div style={{
                height: '100%',
                backgroundColor: item.color,
                width: `${pct}%`,
                borderRadius: '0 3px 3px 0',
                minWidth: '2px',
                transition: 'width 0.5s ease-in-out'
              }} data-id="element-892" />
                </div>
                <div className="flex items-center gap-2 flex-shrink-0" style={{
              minWidth: '64px',
              justifyContent: 'flex-end'
            }} data-id="element-893">
                  <span style={{
                fontFamily: 'Roboto Condensed, sans-serif',
                fontSize: '16px',
                fontWeight: 500,
                color: '#293B54'
              }} data-id="element-894">
                    {item.val}
                  </span>
                  <span style={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '12px',
                color: '#AAAAAA'
              }} data-id="element-895">
                    ({pct}%)
                  </span>
                </div>
              </div>;
        })}
        </div>

        {/* Totale Footer */}
        <div className="mt-8 pt-6 flex items-center justify-between" style={{
        borderTop: '1px solid #E4E4E4'
      }} data-id="element-896">
          <div style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#293B54'
        }} data-id="element-897">
            Totale
          </div>
          <div className="flex items-center gap-2" data-id="element-898">
            <Icon icon="tabler:sigma" fontSize={22} style={{
            color: '#80858E'
          }} data-id="element-899" />
            <span style={{
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '20px',
            fontWeight: 500,
            color: '#293B54'
          }} data-id="element-900">
              40
            </span>
          </div>
        </div>
      </div>
    </div>;
}